export default __webpack_public_path__ + "media/images/favicon/favicon-32x32-cf049326db40ca30bbf09907d9411739.png";